import React, { Component } from 'react'
import propTypes from 'prop-types'
import { observer } from 'mobx-react'
import classNames from 'classnames'
import { Typeahead } from '@components/Autocomplete'
import get from 'lodash/get'

class TypeahedField extends Component {
  static propTypes = {
    field: propTypes.shape({
      name: propTypes.string,
    }).isRequired,
    form: propTypes.object,
    itemToString: propTypes.func,
    label: propTypes.string,
    loadOptions: propTypes.func,
    onChange: propTypes.func,
  }

  render() {
    const { field, form, label, loadOptions, onChange, itemToString, ...props } = this.props

    const error = get(form.touched, field.name) && get(form.errors, field.name)
    const value = get(form.values, field.name)

    const groupClasses = classNames({
      'form__input-group': true,
      'form__input-group--relative': true,
      'form__input-group--error': error,
    })

    const wrapperClasses = classNames({
      'form__input-wrapper': true,
      'form__input-wrapper--error': error,
    })

    const typeaheadProps = {
      className: 'form__input form__input--autocomplete',
      value,
      loadOptions: this.props.loadOptions,
      itemToString,
      onBlur: () => {
        form.setFieldTouched(field.name, true)
      },
      onChange: (option) => {
        if (!onChange) {
          form.setFieldValue(field.name, option, false)
        } else {
          onChange(option)
        }
        form.setFieldTouched(field.name, true)
      },
      ...props,
    }

    let errorDisplay

    if (typeof error === 'string') {
      errorDisplay = <div className="form__input-error">{error}</div>
    } else if (error) {
      errorDisplay = Object.values(error).map((message) => (
        <div key={message} className="form__input-error">
          {message}
        </div>
      ))
    } else {
      errorDisplay = null
    }

    return (
      <div className={groupClasses}>
        <label className="form__label">{label}</label>
        <div className={wrapperClasses}>
          <Typeahead {...typeaheadProps} />
          {errorDisplay}
        </div>
      </div>
    )
  }
}

export default observer(TypeahedField)
